import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { DefaultTopLevelGroup, Status } from "../../../../common/constants";
import { listDasSubscriptionsUrl } from "../../../../config";
import { RootState } from "../../../../store";
import api from "../../../../api";
import { IDasSubscriptionsApi, IDasSubscriptions} from '../../../../common/types/dasTypes';

export const GET_DAS_SUBSCRIPTIONS: string = "getDasSubscriptions";

const initialState: IDasSubscriptionsApi = {
  dasSubscriptions: null,
  status: Status.IDLE,
  error: null,
};

export const fetchDasSubscriptionsData = createAsyncThunk(GET_DAS_SUBSCRIPTIONS, async () => {
  try {
    const response = await api.get(listDasSubscriptionsUrl + `?orgId=${DefaultTopLevelGroup.ID}`);
    const dasSubscriptionData: IDasSubscriptions = response.data;
    return dasSubscriptionData;
  } catch (error) {
    throw error;
  }
});

const dasSubscriptionSlice = createSlice({
  name: GET_DAS_SUBSCRIPTIONS,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDasSubscriptionsData.pending, (state) => {
        state.status = Status.PENDING;
      })
      .addCase(fetchDasSubscriptionsData.fulfilled, (state, action) => {
        state.status = Status.SUCCESS;
        state.dasSubscriptions = action.payload;
      })
      .addCase(fetchDasSubscriptionsData.rejected, (state, action) => {
        state.status = Status.FAILED;
        state.error = action.error.message || null;
      });
  },
});

export const selector = (state: RootState) => state.dasSubscriptionsApi;

export const reducer = dasSubscriptionSlice.reducer;
